import PortalRoleAndAssignmentTypes from "../types/portalRoleTypes/PortalRoleAndAssignmentTypes"
import PortalRoleTemplatePortalRoleLnkTypes from "../types/portalTemplateTypes/PortalRoleTemplatePortalRoleLnkTypes"
import PortalRoleTemplateWithLnksTypes from "../types/portalTemplateTypes/PortalRoleTemplateWithLnksTypes"
import hashTable from "./HashTable"

const storageSize = 2500

const roleHashTable = new hashTable(storageSize)
const roleLinkHashTable = new hashTable(storageSize)
const templateHashTable = new hashTable(storageSize)

const ratmHash = {
    buildRoleHashTable: (rolesAndAssignments: PortalRoleAndAssignmentTypes[]) => {
        roleHashTable.purgeTable(false)
        for (let i = 0; i < rolesAndAssignments.length; i++) {
            const role = rolesAndAssignments[i].Role
            const assignments = rolesAndAssignments[i].Assignments
            roleHashTable.addItem([`${role.PortalRoleId}`, { role: role }, {assignments: assignments}])
        }
        const storage = roleHashTable.getStorage()
        // console.log("buildRoleHashTable storage", storage)
        return storage
    },
    buildTemplateHashTable: (templates: PortalRoleTemplateWithLnksTypes[]) => {
        templateHashTable.purgeTable(false)
        for (let i = 0; i < templates.length; i++) {
            const templateItem = templates[i]
            let rolesFromRoleList: PortalRoleAndAssignmentTypes[] = []
            for (let j = 0; j < templateItem.RoleTemplatePortalRoleLnk.length; j++) {
                const linkedRole = templateItem.RoleTemplatePortalRoleLnk[j]
                const lrpri = linkedRole.PortalRoleId ? linkedRole.PortalRoleId : -1
                let bucketItem = ratmHash.lookupHashTableItem(lrpri, 0)
                if (bucketItem) {
                    let role = ratmHash.lookupHashTableItem(lrpri, 0)[1].role
                    rolesFromRoleList.push(role)
                }
            }

            templateHashTable.addItem([
                `${templateItem.Template.RoleTemplateId}`,
                { templateItem: templateItem },
                { rolesFromRoleList: rolesFromRoleList },
                { modified: false }
            ])
        }
        const storage = templateHashTable.getStorage()
        // console.log("buildTemplateHashTable", storage)
        return storage
    },
    buildRoleLinkHashTable: (links: PortalRoleTemplatePortalRoleLnkTypes[]) => {
        roleLinkHashTable.purgeTable(false)
        for (let i = 0; i < links.length; i++) {
            const linkedRole = links[i]
            const item = [
                `${linkedRole.PortalRoleId}`,
                { RoleTemplatePortalRoleLnk: linkedRole },
                {
                    permissions: {
                        hasRole: !linkedRole.DeletedDateUTC,
                        dropRole: false,
                        addRole: false,
                        hasEdit: linkedRole.Edit,
                        dropEdit: false,
                        addEdit: false,
                        hasView: linkedRole.View,
                        dropView: false,
                        addView: false
                    }
                },
                { modified: false }
            ]
            roleLinkHashTable.addItem(item)
        }
        const storage = roleLinkHashTable.getStorage()
        // console.log("buildRoleLinkHashTable", storage)
        return storage
    },
    getStorage: (tableIdentifier: number) => {
        const storage = ratmHash.getTableByIdentifier(tableIdentifier).getStorage()
        return storage
    },
    getTableByIdentifier: (tableIdentifier: number) => {
        const table = tableIdentifier === 0 ? roleHashTable : tableIdentifier === 1 ? templateHashTable : tableIdentifier === 2 ? roleLinkHashTable : roleHashTable
        return table
    },
    lookupHashTableItem: (id: number, tableIdentifier: number) => {
        const item = ratmHash.getTableByIdentifier(tableIdentifier).lookupItem([`${id}`])
        return item
    },
    purgeHashTable: (tableIdentifier: number) => {
        ratmHash.getTableByIdentifier(tableIdentifier).purgeTable(false)
    },
    updateHashTableItem: (bucketItem: any, tableIdentifier: number, markModified: boolean) => {
        ratmHash.getTableByIdentifier(tableIdentifier).updateItem(bucketItem, markModified)
    },
    addHashTableItem: (bucketItem: any, tableIdentifier: number) => {
        ratmHash.getTableByIdentifier(tableIdentifier).addItem(bucketItem)
        // console.log(ratmHash.getStorage(tableIdentifier))
    },
    deleteHashTableItem: (bucketItem: any, tableIdentifier: number) => {
        ratmHash.getTableByIdentifier(tableIdentifier).deleteItem(bucketItem[0])
    }
}

export default ratmHash